import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

import { Link, useNavigate } from "react-router-dom";

import "./AllAssignmentUniversity.css";
import { useEffect, useState } from "react";
import axios from "axios";

const AllAssignmentUniversity = () => {
  const [universities, setUniversities] = useState([]);
  const [universityId, setUniversityId] = useState("");

  const [courseId, setCourseId] = useState("");
  const [courses, setCourses] = useState([]);

  const [semesterId, setSemesterId] = useState("");
  const [semesters, setSemesters] = useState([]);

  const [universitySubjects, setUniversitySubjects] = useState([]);
  const [universitySubjectId, setUniversitySubjectsId] = useState();

  const [language, setLanguage] = useState("");
  const [universitiesAssignment, setUniversitiesAssignment] = useState([]);

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/universities`)
      .then((response) => {
        const universitiesData = response.data?.data || [];
        setUniversities(universitiesData);
      })
      .catch((error) => console.log(error));
  }, [API_BASE_URL]);

  useEffect(() => {
    if (universityId) {
      axios
        .get(`${API_BASE_URL}/all-courses/${universityId}`)
        .then((response) => {
          const coursesData = response.data?.data || [];
          setCourses(coursesData);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [universityId]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/semesters`)
      .then((response) => {
        const semesterData = response.data?.data || [];
        setSemesters(semesterData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (courseId) {
      axios
        .get(
          `${API_BASE_URL}/college-subjects?courseId=${courseId}&semesterId=${semesterId}`
        )
        .then((response) => {
          const UniversitySubjects = response.data?.data || [];
          setUniversitySubjects(UniversitySubjects);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [courseId, semesterId]);

  useEffect(() => {
    axios
      .get(
        `${API_BASE_URL}/assignment?subjectId=${universitySubjectId}&language=${language}`
      )
      .then((response) => {
        // console.log(response);
        setUniversitiesAssignment(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [universitySubjectId, language]);

  const handleEdit = (id) => {
    navigate(`/student-assignment/edit-university/${id}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this assignment?")) {
      axios
        .delete(`${API_BASE_URL}/admin/assignment/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          if (response.data.success) {
            setUniversitiesAssignment((prevAssignments) =>
              prevAssignments.filter((assignment) => assignment._id !== id)
            );
            alert("Assignment deleted successfully!");
          } else {
            alert(response.data.message || "Failed to delete assignment.");
          }
        })
        .catch((error) => {
          console.error("Error deleting assignment:", error);
          alert(
            "An error occurred while deleting the assignment. Please try again."
          );
        });
    }
  };

  return (
    <>
      <div id="university-all-assignments-table">
        <div className="university-all-ass-heading-or-btns">
          <h4>University Assignments</h4>
          <div className="university-all-ass-nav-btns">
            <button onClick={() => navigate("/student-assignment/university")}>
              University Assignment
            </button>
            <button>University All Assignments</button>
          </div>
        </div>
        <div>
          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Select University</label>
            <select
              className="new-chapter-dropdown"
              value={universityId}
              onChange={(e) => {
                setUniversityId(e.target.value);
              }}
              required
            >
              <option value="">-Select University-</option>
              {universities.map((universitie, idx) => (
                <option key={idx} value={universitie._id}>
                  {universitie.universityName}
                </option>
              ))}
            </select>
          </div>

          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Course Name</label>
            <select
              className="new-chapter-dropdown"
              value={courseId}
              onChange={(e) => {
                setCourseId(e.target.value);
              }}
              required
            >
              <option value="">-Select Course-</option>
              {courses.map((course, idx) => (
                <option key={idx} value={course._id}>
                  {course.courseName}
                </option>
              ))}
            </select>
          </div>

          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Semester</label>
            <select
              className="new-chapter-dropdown"
              value={semesterId}
              onChange={(e) => {
                setSemesterId(e.target.value);
              }}
              required
            >
              <option value="">-Select Semester-</option>
              {semesters.map((semester, idx) => (
                <option key={idx} value={semester._id}>
                  {semester.semesterName}
                </option>
              ))}
            </select>
          </div>

          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Subject</label>
            <select
              className="new-chapter-dropdown"
              value={universitySubjectId}
              onChange={(e) => {
                setUniversitySubjectsId(e.target.value);
              }}
              required
            >
              <option value="">-Select Subject-</option>
              {universitySubjects.map((universitySubject, idx) => (
                <option key={idx} value={universitySubject._id}>
                  {universitySubject.subjectName}
                </option>
              ))}
            </select>
          </div>

          <div className="new-chapter-form-group">
            <label className="new-chapter-label">Language</label>
            <select
              className="new-chapter-dropdown"
              value={language}
              onChange={(e) => {
                setLanguage(e.target.value);
              }}
              required
            >
              <option value="">-Select Subject-</option>
              <option value="english">English</option>
              <option value="hindi">Hindi</option>
            </select>
          </div>
        </div>
        <div className="university-all-assignment-inner">
          <table>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Title</th>
                <th>File</th>
                <th>Subjects</th>
                <th>Language</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {universitiesAssignment.length > 0 ? (
                universitiesAssignment &&
                universitiesAssignment.map((item, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{item.title}</td>
                    <td>
                      <Link to={`${API_BASE_URL}/uploads/${item.filePath}`}>
                        {item.filePath}
                      </Link>
                    </td>
                    <td>{item.subject}</td>
                    <td>{item.language}</td>
                    <td>
                      <span>
                        <FaEdit onClick={() => handleEdit(item._id)} />
                      </span>
                      <span>
                        <MdDelete onClick={() => handleDelete(item._id)} />
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    <h2>No data Found</h2>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AllAssignmentUniversity;
